import * as React from 'react';
import * as styles from './SubscriptionService.css';
import { ISubscriptionServiceProps } from './types';
import { DiscountLabel } from '../DiscountLabel';
import { ServiceWrapper } from '../ServiceWrapper';

// tslint:disable-next-line: no-implicit-dependencies
const sunglassesIcon = require('!url-loader!./assets/sunglasses.png'); // без url-loader никак не хотел рендериться

export const SubscriptionService = (props: ISubscriptionServiceProps) => {
  const { name, description, title, isActive, discount, handleCardClick } = props;

  return (
    <ServiceWrapper isActive={isActive} className={styles['wrapper']} onClick={handleCardClick}>
      <div className={styles['sunglasses_wrapper']}>
        <img src={sunglassesIcon} width={52} height={52} className={styles['sunglasses']} />
      </div>

      <div className={styles['discount_wrapper']}>
        <DiscountLabel discount={discount} />
      </div>

      <div className={styles['body']}>
        <div className={styles['name']}>{name}</div>
        <div className={styles['title']}>{title}</div>
        <div className={styles['description']}>{description}</div>
      </div>
    </ServiceWrapper>
  );
};
